var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.177C1 11.1465 1 10.1313 1.47051 9.23891C1.94101 8.34653 2.82463 7.68583 4.59186 6.36443L6.30615 5.08262C9.5004 2.69421 11.0975 1.5 13 1.5C14.9025 1.5 16.4996 2.69421 19.6939 5.08262L21.4081 6.36443C23.1754 7.68583 24.059 8.34653 24.5295 9.23891C25 10.1313 25 11.1465 25 13.177V19.5182C25 22.3381 25 23.748 23.9958 24.624C22.9916 25.5 21.3753 25.5 18.1429 25.5H7.85714C4.62465 25.5 3.00841 25.5 2.00421 24.624C1 23.748 1 22.3381 1 19.5182V13.177Z",
    stroke: "#00A898",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2858 24.284V17.1398C17.2858 16.5875 16.8381 16.1398 16.2858 16.1398H9.71436C9.16207 16.1398 8.71436 16.5875 8.71436 17.1398V24.284",
    stroke: "#00A898",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHomeActive);
export default __webpack_public_path__ + "static/media/menu-home-active.866ed949ddb91ae229b6dce7066b76d3.svg";
export { ForwardRef as ReactComponent };